import { render, staticRenderFns } from "./On-Demand-Delivery-System.vue?vue&type=template&id=830c27fc&scoped=true"
import script from "./On-Demand-Delivery-System.vue?vue&type=script&lang=js"
export * from "./On-Demand-Delivery-System.vue?vue&type=script&lang=js"
import style0 from "./On-Demand-Delivery-System.vue?vue&type=style&index=0&id=830c27fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c27fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFeatures: require('/home/rohit/Documents/GitHub/aibuddha-website/components/ProductsFeatures.vue').default,Testimonials: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Testimonials.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
